export interface StoredSession {
  email: string;
  access_token: string;
  device_token: string | null;
  name: string;
  role: string;
  account_type: string;
  account_name: string;
  account_reference: string;
  user_reference: string;
  assigned_smtp: string;
  smtp_from: string;
  expires_in: string;
  added_at: number;
  img?: string;
}

export const MAX_SESSIONS = 5;
